module.exports = __webpack_public_path__ + "media/img/down-black-4f5614ac38a08c7f373d61555af38e4a.svg";